import React from 'react'
import { NavLink } from 'react-router-dom'
import { Option, toRelativeUrl, decodeHTMLEntities } from '../../../helpers'
import { WordPress, withDataState } from '../../wordpress/wordpress_api'

type Props = {
  location: string
}

type State = withDataState<WordPress.MenuLocationResponse>

export default class FooterColumns extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      kind: 'loading'
    }
  }

  componentDidMount() {
    WordPress.findMenuByLocation(this.props.location)
      .then(response => {
        this.setState({ kind: 'loaded', data: Option(response.data) })
      })
      .catch(() => this.setState({ kind: 'error' }))
  }

  render() {
    return (
      this.state.kind === 'loaded' &&
      this.state.data.kind === 'some' && (
        <div className="footer__columns">
          <div className="footer__columns-inner container container--l grid--gutter">
           <div className="grid grid--footer">
              {this.state.data.value.map((menuItem: WordPress.MenuItem, index: number) => (
                <div className="grid__column" key={`column-${index}`}>
                  <h3 className="footer__title">{menuItem.title}</h3>
                  {menuItem.children && menuItem.children.length > 0 && (
                    <ul className="footer__list">
                      {menuItem.children.map((child: WordPress.MenuItem, subindex: number) =>
                        child.type == 'custom' ? (
                          <li className="footer__item" key={`item-${index}-${subindex}`}>
                            <a href={child.url} className="footer__link" target={child.target}>
                              <svg
                                className="footer__icon"
                                width="8px"
                                height="5px"
                                aria-hidden="true"
                              >
                                <use xlinkHref="#icon--chevron" />
                              </svg>
                              <span>{decodeHTMLEntities(child.title)}</span>
                            </a>
                          </li>
                        ) : (
                          <li className="footer__item" key={`item-${index}-${subindex}`}>
                            <NavLink to={toRelativeUrl(child.url)} className="footer__link">
                              <svg
                                className="footer__icon"
                                width="8px"
                                height="5px"
                                aria-hidden="true"
                              >
                                <use xlinkHref="#icon--chevron" />
                              </svg>
                              <span>{decodeHTMLEntities(child.title)}</span>
                            </NavLink>
                          </li>
                        )
                      )}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/footer_columns.tsx